import script from "./SalleDeBainView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalleDeBainView.vue?vue&type=script&setup=true&lang=js"

import "./SalleDeBainView.vue?vue&type=style&index=0&id=57d3265e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d3265e"]])

export default __exports__